import { useEffect, useState } from 'react';
import { indexDocument, search } from '../search';
import { Resource, ResourceSearchResult } from './types';
import { useAppSelector } from '../../store';

export const indexResource = (resource: Resource) => {
  indexDocument(`${resource.id}@`, resource.title);

  resource.content.forEach(
    (block, blockIdx) => {
      block.content.forEach(
        (lineGroup, groupIdx) => {
          lineGroup.forEach(
            (line, lineIdx) => indexDocument(
              `${resource.id}@${blockIdx},${groupIdx},${lineIdx}`,
              line[0]
            )
          );
        }
      );
    }
  );
};

const sortSearchResults = (a: ResourceSearchResult, b: ResourceSearchResult) => {
  if (b.resource.meta.lastUsed) {
    if (a.resource.meta.lastUsed) {
      return b.resource.meta.lastUsed - a.resource.meta.lastUsed;
    }
    // b has been used, a has not
    return 1;
  }
  else if (a.resource.meta.lastUsed) {
    // a has been used, b has not
    return -1;
  }
  else {
    return (b.resource.meta.created || 0) - (a.resource.meta.created || 0);
  }
};

export const useResourceSearch = (searchText: string) => {
  const [results, setResults] = useState<ResourceSearchResult[]>([]);
  const [searching, setSearching] = useState<boolean>(false);
  const [returned, setReturned] = useState<boolean>(false);
  const resources = useAppSelector(state => state.resources);

  useEffect(
    () => {
      if (searchText.length > 3) {
        setSearching(true);
        setReturned(false);
        search(searchText).then(
          rawResults => {
            const parsedResults = {} as Record<string, ResourceSearchResult>;
            for (const result of rawResults) {
              const [id, address] = result.split('@');
              if (resources[id]) {
                if (!parsedResults[id]) {
                  parsedResults[id] = {
                    resource: resources[id],
                    locations: []
                  };
                }

                if (address) {
                  const [block, group, line] = address.split(',').map(a => parseInt(a, 10));
                  parsedResults[id].locations.push({ block, group, line });
                }
              }
            }

            setResults(Object.values(parsedResults).sort(sortSearchResults));
            setReturned(true);
            setSearching(false);
          }
        );
      }
      else {
        setResults([]);
        setSearching(false);
        setReturned(false);
      }
    },
    [resources, searchText]
  );

  return {
    searching,
    results,
    returned
  };
};
